const KlarnaIcon = /*#__PURE__*/ [
  ["circle", { cx: "20", cy: "18.5", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["rect", { x: "2", y: "3.5", width: "4", height: "17", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15 3.5H11.1985C11.1985 9.8463 6 12.5 6 12.5L11.8931 20.5H16.5L11 13C11 13 15 10 15 3.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export { KlarnaIcon as default };
//# sourceMappingURL=KlarnaIcon.js.map
